import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=04d778aa&"
import script from "./Password.vue?vue&type=script&lang=js&"
export * from "./Password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports